const range = require('lodash/range');
const plugin = require('tailwindcss/plugin');

const innerBorderUtils = plugin(function ({addUtilities}) {
  addUtilities(
    range(0.5, 10, 0.5).map(num => {
      return {
        [`.inner-line-${num}px`]: {
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            'box-shadow': `0 0 0 ${num}px var(--inner-line-color) inset`,
            'pointer-events': 'none',
          },
        },
      };
    })
  );
});

module.exports = innerBorderUtils;
